
/**
 * 返回当前页面的环境，依赖于当前域名
 */
 export function getClientEnv() {
  let env = 'dev';
  if (window.location.href.indexOf('dss.test.xiaopeng.local') !== -1) {
    env = 'test';
  } else if (
    window.location.href.indexOf('dss.deploy-test.xiaopeng.com') !== -1
  ) {
    env = 'deploy';
  } else if (window.location.href.indexOf('dss.xiaopeng.com') !== -1) {
    env = 'product';
  }
  return env;
}